import ApiClient from './ApiClient'

export default class MessagesClient extends ApiClient {
    getAll = (page = 1, filterUser = '', filterRoom = '', sortBy = '') =>
        this.get('/messages', { page, filter_user: filterUser, filter_room: filterRoom, sort_by: sortBy })

    deleteMessage = messageId => this.delete(`/messages/${messageId}`)
}
